import React, { useLayoutEffect, useRef, useCallback } from 'react';
import cmsUtils from '../../cmsUtils';
import utils from '../../../../utils';

import { useRouter } from '../../../../components';

import { handleElementLink } from '../../../../components';
import env from '../../../../env';
import { renderHtml } from './renderHtml';

//import { Document, Page } from 'react-pdf'
//import { Document, Page } from 'react-pdf/dist/entry.webpack';

function getCellContent(cell) {
  return cell ? cell.innerHTML : "";
}

function structureTable(root) {
  if (!root) return;

  root.querySelectorAll('table').forEach((table) => {
    const explicitRowHeader = table.classList.contains('table-row-header');
    const explicitColHeader = table.classList.contains('table-col-header');

    table.classList.add('cms-table');
    table.classList.remove('table-row-header', 'table-col-header');
    table.removeAttribute('align');
    table.removeAttribute('border');
    table.removeAttribute('cellpadding');
    table.removeAttribute('cellspacing');
    table.style.width = '';

    if (explicitRowHeader) {
      table.classList.add('table-row-header');
    } else if (explicitColHeader) {
      table.classList.add('table-col-header');
    } else {
      // Default to column-header mode for product comparison tables:
      // mobile will generate (1+2), (1+3), (1+4) mini tables.
      table.classList.add('table-col-header');
    }
  });
}

let _lastResizeWidth = 0;

function restructureResponsiveTables(container) {
  const isMobile = window.innerWidth < 768;

  container.querySelectorAll("table.cms-table, table.table-row-header, table.table-col-header").forEach((table) => {
    const isRowHeader = table.classList.contains("table-row-header");
    const wrapper = table.parentElement.querySelector('.responsive-table-wrapper[data-source-table]');

    if (!isMobile) {
      table.style.display = "";
      if (wrapper) wrapper.style.display = "none";
      return;
    }

    table.style.display = "none";

    if (wrapper) {
      wrapper.style.display = "";
      return;
    }

    const rows = Array.from(table.querySelectorAll("tr"));
    if (rows.length < 2) return;

    const newWrapper = document.createElement("div");
    newWrapper.className = "responsive-table-wrapper";
    newWrapper.setAttribute("data-source-table", "true");

    if (isRowHeader) {
      const headerCells = Array.from(rows[0].querySelectorAll("th, td"));
      const dataRows = rows.slice(1);

      dataRows.forEach((row) => {
        const cells = Array.from(row.querySelectorAll("th, td"));
        const miniTable = document.createElement("table");
        miniTable.className = "responsive-table responsive-table--row-header";
        const tbody = document.createElement("tbody");

        headerCells.forEach((headerCell, idx) => {
          const tr = document.createElement("tr");
          const th = document.createElement("th");
          th.innerHTML = getCellContent(headerCell);
          const td = document.createElement("td");
          td.innerHTML = getCellContent(cells[idx]);
          tr.appendChild(th);
          tr.appendChild(td);
          tbody.appendChild(tr);
        });

        miniTable.appendChild(tbody);
        newWrapper.appendChild(miniTable);
      });
    } else {
      const headerCells = rows.map((row) => {
        const cells = row.querySelectorAll("th, td");
        return cells.length > 0 ? cells[0] : null;
      });

      const colCount = rows[0] ? rows[0].querySelectorAll("th, td").length : 0;

      for (let col = 1; col < colCount; col++) {
        const miniTable = document.createElement("table");
        miniTable.className = "responsive-table responsive-table--col-header";
        const tbody = document.createElement("tbody");

        rows.forEach((row, rowIdx) => {
          const cells = Array.from(row.querySelectorAll("th, td"));
          const tr = document.createElement("tr");
          const th = document.createElement("th");
          th.innerHTML = getCellContent(headerCells[rowIdx]);
          const td = document.createElement("td");
          td.innerHTML = getCellContent(cells[col]);
          tr.appendChild(th);
          tr.appendChild(td);
          tbody.appendChild(tr);
        });

        miniTable.appendChild(tbody);
        newWrapper.appendChild(miniTable);
      }
    }

    table.parentNode.insertBefore(newWrapper, table.nextSibling);
  });
}

export function Html(props) {
  const ver = env.ver;
  const item = props.item;
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const { history } = useRouter();
  //const [ pdfViewPath, setPdfViewPath ] = React.useState(null)
  //console.log('item', item, cmsOption);

  const year = (new Date()).getFullYear();
  let content = cmsOption.isCmsEdit ?
    cmsUtils.payload(item, 'Content') :
    cmsUtils.payload(item, 'Content')
      .replace(/__year__/g, year)
      .replace("__version__", "<a href = '/app' class = 'app_version'> PWA " + ver + "</a>");

    content = content
      .replace(
        /class="aos_effect_up"/gi,
        `class="aos_effect_up" data-aos="fade-up"`
      )
      .replace(
        /class="aos_effect_down"/gi,
        `class="aos_effect_down" data-aos="fade-down"`
      )
      .replace(
        /class="aos_effect_left"/gi,
        `class="aos_effect_left" data-aos="fade-left"`
      )
      .replace(
        /class="aos_effect_right"/gi,
        `class="aos_effect_right" data-aos="fade-right"`
      );


  const cssClass = utils.classNames('cms_item', 'htmlPanel', cmsOption.isCmsEdit && 'html', item.cssClass || item.anchorName || '');

  //let itemElt = (<div dangerouslySetInnerHTML={{ __html: content }}></div>);

  function handleClick(e) {

    let target = "";
    if (e.target.closest('a')) {
      target = e.target.closest('a').getAttribute('target');
    }
    const processed = (target === "_blank" ? handleElementLink(e.target, null) : handleElementLink(e.target));
    //const link = utils.url.getLinkFromElement(e.target);
    //console.log('clicked', e, e.target, processed);

    if (processed.handled) {
      e.preventDefault();
      e.stopPropagation();
    } else if (processed.linkInfo && processed.linkInfo.type === 'internal') {
      e.preventDefault();
      e.stopPropagation();
      history.push(processed.linkInfo.url)
    } else {
      //e.preventDefault();
      //e.stopPropagation();
      // setPdfViewPath(utils.site.resourcePath(link))

      // process expandable old
      // if(e.target.closest('a')){
      //   let href = e.target.closest('a').getAttribute('href') + "";
      //     if(href.indexOf('#') !== -1){
      //     let _href = href.split('#');
      //     console.log("_href", _href);
      //     let el = document.querySelector('section[data-cms-item-anchor="' + _href[1] + '"]');
      //     if (el) {
      //       let anchorStatus = el.getAttribute('data-anchor-status');
      //       if(anchorStatus === "collapse"){
      //         el.setAttribute('data-anchor-status', 'expand');
      //         el.classList.add("expand");
      //       }
      //       else{
      //         el.setAttribute('data-anchor-status', 'collapse');
      //         el.classList.remove("expand");
      //       }
      //     }
      //     e.preventDefault();
      //     e.stopPropagation(); 
      //   }
      // }

      // process expandable
      if (e.target.closest('a')) {
        let aLink = e.target.closest('a')
        let href = aLink.getAttribute('href') + "";
        if (href.indexOf('#') !== -1) {
          let _href = href.split('#');
          console.log("_href", _href);
          const targetId = _href[1]
          let targetElt = document.querySelector('section[data-cms-item-anchor="' + _href[1] + '"]');

          const runEffect = () => {
            let anchorStatus = targetElt.getAttribute('data-anchor-status');
            if (anchorStatus === "collapse") {
              targetElt.setAttribute('data-anchor-status', 'expand');
              targetElt.classList.add("expand");
            }
            else {
              targetElt.setAttribute('data-anchor-status', 'collapse');
              targetElt.classList.remove("expand");
            }
          }

          if (targetElt) {
            const wrapper = aLink.closest('p, div, h1, h2, h3, h4, h5')
            const nextElt = wrapper.nextElementSibling
            //console.log(wrapper, nextElt)

            if (nextElt && nextElt.getAttribute('data-cms-item-anchor') === targetId) {
              // already in wrapper
            } else {
              // no wrapper
              wrapper.insertAdjacentElement("afterend", targetElt);
            }

            window.setTimeout(runEffect, 100)

            e.preventDefault();
            e.stopPropagation();
          }
        }
      }


    }
  }

  const htmlBlock = useRef(null);

  useLayoutEffect(() => {
    if (!htmlBlock.current) return;

    structureTable(htmlBlock.current);
    if (!cmsOption.isCmsEdit) {
      _lastResizeWidth = window.innerWidth;
      restructureResponsiveTables(htmlBlock.current);
    }
    // eslint-disable-next-line
  }, [content]);

  const handleResize = useCallback(() => {
    const currentWidth = window.innerWidth;
    if (currentWidth === _lastResizeWidth) return;
    _lastResizeWidth = currentWidth;

    if (htmlBlock.current && !cmsOption.isCmsEdit) {
      restructureResponsiveTables(htmlBlock.current);
    }
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  return (
    <>
      <div ref={htmlBlock} className={cssClass} data-cms-html="true"
        data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
        onClick={(e) => handleClick(e)}>
        {renderHtml(content, cmsOption)}
      </div>
    </>
  )
}
